const types = {
  THROW_API_ERROR: '@@api/THROW_API_ERROR',
};

export default types;
